import { IMInputText } from '@insurancemenu/imenu-components-lib';
import { DefaultFormFields, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import React from 'react';
import { UwRate } from 'types/uwService';
import { observer } from 'mobx-react-lite';
import { FormWrapperStyled, IMFormStyled, ProductNameStyled, RatesTypeTextStyled } from './styles';
import { OVERRIDE_RATES_EDIT_PRODUCT_RATES_FORM_TEST_ID } from '../constants';

interface Props {
  productName: string;
  formController: FormController<DefaultFormFields>;
  rates: UwRate[];
}

export const EditProductRatesForm: React.FC<Props> = observer(({ formController, productName, rates }) => {
  return (
    <FormWrapperStyled data-test-id={OVERRIDE_RATES_EDIT_PRODUCT_RATES_FORM_TEST_ID}>
      <ProductNameStyled>{productName}</ProductNameStyled>
      <RatesTypeTextStyled>Updated Rates</RatesTypeTextStyled>
      <IMFormStyled formController={formController} id={`edit-${productName}-rates-form`}>
        {rates.map((rate) => (
          <IMInputText
            htmlType="number"
            key={rate.key}
            name={rate.key}
            label={rate.displayKey}
            additionalOptions={{ contributionType: 'dollar', contributionInterval: '/ month' }}
            size="full"
          />
        ))}
      </IMFormStyled>
    </FormWrapperStyled>
  );
});
